/* libs */
import React, { Fragment, Component } from "react";
import PropTypes from "prop-types";

class SimpleSelectInput extends Component {
	constructor(props) {
		super(props);
		let groups = [];
		let groupObj = {};
		props.values.forEach(option => {
			if (option.group) {
				groupObj[option.group] = option.group;
			}
		});
		Object.keys(groupObj).forEach(group => {
			groups.push(group);
		});
		this.state = {
			minimizePlaceholder: false,
			groups,
		};
	}

	onFocus = () => {
		this.setState({
			minimizePlaceholder: true,
		});
	};

	onBlur = value => {
		if (!value || value.length < 1) {
			this.setState({
				minimizePlaceholder: false,
			});
		}
	};

	render() {
		const { id, onChange, value, error, placeholder, values, isRequired } = this.props;
		var inputProps = {
			id: id,
			...(onChange ? { onChange } : {}),
		};
		let override = false;
		const { minimizePlaceholder } = this.state;

		if (value && value.length > 0 && minimizePlaceholder === false) {
			override = true;
		}
		const isFocused = minimizePlaceholder || override ? " focus" : "";
		const hasError = error ? " has-error" : "";

		let options = [];

		if (this.state.groups.length > 0) {
			this.state.groups.forEach(group => {
				let groupOptions = values.map(value => {
					if (value.group && value.group === group) {
						return (
							<option key={value.key} value={value.value}>
								{value.label}
							</option>
						);
					} else {
						return null;
					}
				});
				options.push(<optgroup label={group}>{groupOptions}</optgroup>);
			});
		} else {
			options = values.map(value => (
				<option key={value.key} value={value.value}>
					{value.label}
				</option>
			));
		}
		return (
			<Fragment>
				<div className={`select-wrap${isFocused}${hasError}`}>
					<div className="placeholder">
						<span className={isFocused ? "caption-text" : ""}>
							{isRequired && <span className="isrequired-label">*</span>}
							{placeholder}
						</span>
					</div>
					<div className="select-arrow">
						<i className="fal fa-chevron-down"></i>
					</div>
					<div className="select-box">
						<select value={value} className={hasError} {...inputProps}>
							{placeholder && (
								<option key="default" value="" disabled={!this.props.defaultEnabled}></option>
							)}
							{options}
						</select>
					</div>
					{error ? <small className="error-message">{error}</small> : null}
				</div>
			</Fragment>
		);
	}
}

SimpleSelectInput.propTypes = {
	autocomplete: PropTypes.string,
	defaultEnabled: PropTypes.bool,
	field: PropTypes.string,
	fieldState: PropTypes.object,
	id: PropTypes.string,
	isRequired: PropTypes.bool,
	minLength: PropTypes.number,
	maxLength: PropTypes.number,
	onChange: PropTypes.func,
	placeholder: PropTypes.string,
	regexMessage: PropTypes.string,
	validationRegex: PropTypes.string,
	values: PropTypes.array,
};

export default SimpleSelectInput;
